<template>
  <div class="userDetail">
    <el-dialog
      title="历史设备"
      :visible.sync="mskflag"
      width="700"
      :before-close="closefn"
    >
      <div class="table">
        <el-table :data="hisDevList" :border="true" style="width: 100%">
          <el-table-column align="center" type="index" label="序号">
          </el-table-column>
          <el-table-column align="center" prop="date" label="设备型号">
            <template slot-scope="scope">
              {{ scope.row.DeviceType || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="设备编号">
            <template slot-scope="scope">
              {{ scope.row.DeviceId || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="绑定时间">
            <template slot-scope="scope">
              {{ scope.row.BindTime || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="解绑时间">
            <template slot-scope="scope">
              {{ scope.row.UnbindTime || "-" }}
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            :current-page="hisDevPage"
            layout="total,prev, pager, next"
            @current-change="currentChangefn"
            :total="userInfoData.DeviceCount"
            :page-size="hisDevSize"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <div class="detailcontent">
      <div class="back" @click="backfn">
        <i class="el-icon-back"></i> <span>返回上一页</span>
      </div>
      <el-tabs v-model="activeIndex" @tab-click="handleClick" type="card">
        <el-tab-pane label="概况" name="first">
          <el-descriptions title="账号信息 " :column="2">
            <el-descriptions-item label="注册方式">{{
              userInfoData.RegType == 2
                ? "手机"
                : userInfoData.RegType == 1
                ? "邮箱"
                : "未知"
            }}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{
              userInfoData.Mobile || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="国家码">{{
              userInfoData.Prefix || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="国家">{{
              userInfoData.Country || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="邮箱">{{
              userInfoData.Email || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="状态">{{
              userInfoData.Status ? "不可用" : "可用"
            }}</el-descriptions-item>
            <el-descriptions-item label="最后活跃时间"
              >{{ userInfoData.LastLogin }}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="个人信息 " :column="2">
            <el-descriptions-item label="昵称">{{
              userInfoData.NickName || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{
              userInfoData.Gender == 0 ? "男" : "女"
            }}</el-descriptions-item>
            <el-descriptions-item label="身高">{{
              userInfoData.Nheight || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="体重"
              >{{ userInfoData.Nweight || "-" }}({{
                bmi
              }})</el-descriptions-item
            >
            <el-descriptions-item label="生日">{{
              userInfoData.Birth | birthHand
            }}</el-descriptions-item>
            <el-descriptions-item label="年龄">{{
              userInfoData.Age ? userInfoData.Age + "岁" : "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="头像">
              <el-image
                style="width: 80px; height: 80px"
                :src="userInfoData.HeadPic"
                fit="cover"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i></div
              ></el-image>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="设备信息 " :column="2">
            <el-descriptions-item label="当前设备型号">{{
              userInfoData.DeviceType || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="当前设备编号">{{
              userInfoData.DeviceId || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="绑定时间">{{
              userInfoData.CreateTime || "-"
            }}</el-descriptions-item>

            <el-descriptions-item label="历史设备"
              ><span class="sp" @click="historyfn">{{
                userInfoData.DeviceCount || "0"
              }}</span></el-descriptions-item
            >
            <el-descriptions-item label="设备版本号"
              ><span>{{
                userInfoData.DeviceVersion || "-"
              }}</span></el-descriptions-item
            >
          </el-descriptions>
          <el-descriptions title="终端信息 " :column="2">
            <el-descriptions-item label="最近访问终端">{{
              userInfoData.Agent || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="终端版本">{{
              userInfoData.AppOsVersion || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="应用版本号">{{
              userInfoData.AppVersion || "-"
            }}</el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="亲友" name="second">
          <el-radio-group
            v-model="tabIndex"
            @change="changeRadiofn"
            style="margin-bottom: 30px"
          >
            <el-radio-button label="0">他关注的</el-radio-button>
            <el-radio-button label="1">关注他的</el-radio-button>
          </el-radio-group>
          <el-table
            v-loading="loading"
            :border="true"
            empty-text="暂无数据"
            :data="tableData"
            stripe
            style="width: 100%"
          >
            <el-table-column align="center" label="序号" type="index">
            </el-table-column>
            <el-table-column align="center" label="ID">
              <template slot-scope="scope">
                {{ scope.row.id || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="国家">
              <template slot-scope="scope">
                {{ scope.row.Country || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="国家码">
              <template slot-scope="scope">
                {{ scope.row.Prefix || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="手机号">
              <template slot-scope="scope">
                {{ scope.row.Mobile || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="邮箱">
              <template slot-scope="scope">
                {{ scope.row.Email || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="昵称">
              <template slot-scope="scope">
                {{ scope.row.NickName || "-" }}
              </template>
            </el-table-column>

            <el-table-column align="center" label="设备">
              <template slot-scope="scope">
                {{ scope.row.DeviceType || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="性别" width="100">
              <template slot-scope="scope">
                {{ scope.row.Gender ? "女" : "男" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="注册时间">
              <template slot-scope="scope">
                {{ scope.row.CreateTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="最后登录时间">
              <template slot-scope="scope">
                {{ scope.row.LastLogin || "-" }}
              </template>
            </el-table-column>

            <el-table-column align="center" label="状态">
              <template slot-scope="scope">
                {{ scope.row.Status ? "不可用" : "可用" }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              fixed="right"
              label="操作"
              width="120"
            >
              <template slot-scope="scope">
                <span class="blue" @click="detailfn(scope.row.id)"> 详情 </span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="健康数据" name="third">
          <el-table :border="true" :data="healthData" style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column align="center" label="项目">
              <template slot-scope="scope">
                {{ scope.row.Module || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="num" label="数量">
              <template slot-scope="scope">
                {{ scope.row.Total || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="date" label="最近更新时间">
              <template slot-scope="scope">
                {{ scope.row.LastTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" fixed="right" label="操作">
              <template slot-scope="scope">
                <router-link
                  :to="{
                    path: scope.row.path,
                    query: {
                      id: $route.query.id,
                      tabs: $route.query.tabs,
                    },
                  }"
                >
                  <span @click="clkfn"> 详情 </span>
                </router-link>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="会员信息" name="vip">
          <user-vip></user-vip>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import UserVip from "./detail/userVip";
import {
  requestUserDetail,
  requestDeviceHistory,
  requestUserCollect,
  requestUserFollower,
  requestUserHealthData,
} from "../../api/userApi.js";
export default {
  name: "userDetail",
  components: { UserVip },
  data() {
    return {
      loading: false,
      mskflag: false,
      activeIndex: "first",
      tabIndex: 0,
      tabflag: false,
      hisDevPage: 1,
      hisDevSize: 5,
      // hisDevTotal:0,
      hisDevList: [],
      userInfoData: {},
      healthDataSort: [
        "血压",
        "心率",
        "HRV",
        "血氧",
        "睡眠",
        "运动",
        "步数",
        "热量",
        "体重",
      ],
      healthData: [
        {
          num: 2,
          date: 24,
          project: "血压",
          path: "/bloodPressure",
        },
        {
          num: 2,
          date: 24,
          project: "心率",
          path: "/bloodPreheartRate",
        },
        {
          num: 2,
          date: 24,
          project: "HRV",
          path: "/HRV",
        },
        {
          num: 2,
          date: 24,
          project: "血氧",
          path: "/bloodOxygen",
        },
        {
          num: 2,
          date: 24,
          project: "运动",
          path: "/exercise",
        },
        {
          num: 2,
          date: 24,
          project: "步数",
          path: "/step",
        },
        {
          num: 2,
          date: 24,
          project: "热量",
          path: "/Calories",
        },
        {
          num: 2,
          date: 24,
          project: "睡眠",
          path: "/sleep",
        },
      ],
      tableData: [
        {
          id: 999,
          CreateTime: "2020-07-30 11:37:33",
          Email: "iii@163.com",
          LastLogin: "2021-11-29 15:44:47",
          Mobile: "18868959123",
          Prefix: "+86",
          Status: 0,
          Time: "2020-07-30T11:37:33Z",
          UserInfo: {
            Gender: 0,
            NickName: "昵称ooo3333",
            UserId: 599,
          },
        },
      ],
    };
  },
  created() {
    this.activeIndex = this.$route.query.tabs;

    this.init();
  },
  computed: {
    bmi() {
      if (this.userInfoData.Nheight && this.userInfoData.Nweight) {
        var h = this.userInfoData.Nheight / 100;
        var w = this.userInfoData.Nweight;

        var b = w / (h * h);
        if (b < 18.5) {
          return "偏瘦";
        } else if (b < 25) {
          return "标准";
        } else if (b < 30) {
          return "超重";
        } else if (b < 35) {
          return "肥胖";
        } else if (b < 40) {
          return "重度肥胖";
        } else {
          return "极重度肥胖";
        }
      } else {
        return "--";
      }
    },
  },
  filters: {
    birthHand(date) {
      if (date) {
        return date.slice(0, 7);
      } else {
        return "-";
      }
    },
  },
  // beforeDestroy(){
  //   if(this.tabflag){
  //     this.$store.commit("changeTabs",this.activeIndex)

  //   }else{
  //     this.$store.commit("changeTabs","first")

  //   }

  // },
  methods: {
    handleClick() {
      if (this.activeIndex != this.$route.query.tabs) {
        this.$router.replace({
          query: {
            id: this.$store.state.id,
            tabs: this.activeIndex,
          },
        });
      }
    },
    clkfn() {
      this.tabflag = true;
    },
    backfn() {
      console.log(history.length);
      if (history.length >= 3) {
        this.$router.go(-1);
      } else {
        this.$message("当前页面为初始页面");
      }
    },
    init() {
      if (this.$route.query.id) {
        this.$store.commit("changeId", this.$route.query.id);
      } else {
        this.$router.replace({
          query: {
            id: this.$store.state.id,
          },
        });
      }
      this.requestUserCollectfn();
      this.requestUserDetailfn().then(() => {});
      this.requestUserHealthDatafn();
    },
    detailfn(id) {
      this.activeIndex = "first";
      this.$router.replace({
        query: {
          id,
          tabs: this.$route.query.tabs,
        },
      });
      this.tabIndex = 0;
      this.init();
    },
    currentChangefn(index) {
      this.hisDevPage = index;
      this.requestDeviceHistoryfn();
    },
    async requestUserHealthDatafn() {
      try {
        var res = await requestUserHealthData({
          userId: this.$route.query.id,
        });
        res = JSON.parse(JSON.stringify(res.data.data.result));
        var arr = [];
        for (var key in res) {
          var path = "/" + key;
          res[key].path = path;
          arr.push(res[key]);
        }
        var arr1 = [];
        this.healthDataSort.forEach((item) => {
          arr.forEach((ite) => {
            if (item == ite.Module) {
              arr1.push(ite);
            }
          });
        });
        this.healthData = arr1;
      } catch (err) {
        console.log(err);
      }
    },
    async requestDeviceHistoryfn() {
      try {
        var res = await requestDeviceHistory({
          userId: this.$route.query.id,
          page: this.hisDevPage,
          size: this.hisDevSize,
        });
        if (res.data.data.result) {
          this.hisDevList = res.data.data.result;
          // this.hisDevTotal = res.data.data.result.length;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async changeRadiofn(index) {
      this.loading = true;
      if (index == 1) {
        await this.requestUserFollowerfn();
      } else {
        await this.requestUserCollectfn();
      }
      this.loading = false;
    },
    async requestUserCollectfn() {
      try {
        var res = await requestUserCollect({
          userId: this.$route.query.id,
        });
        this.tableData = res.data.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    async requestUserFollowerfn() {
      try {
        var res = await requestUserFollower({
          userId: this.$route.query.id,
        });
        this.tableData = res.data.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    async requestUserDetailfn() {
      try {
        var res = await requestUserDetail({
          id: this.$route.query.id,
        });
        this.userInfoData = res.data.data.result;
        console.log(this.userInfoData);
      } catch (err) {
        console.log(err);
      }
    },
    closefn() {
      this.hisDevPage = 1;
      this.mskflag = false;
    },
    historyfn() {
      this.mskflag = true;
      this.requestDeviceHistoryfn();
    },
  },
};
</script>

<style lang="less">
.el-main {
  // padding: 0 !important;
}
table {
  width: 100%;
}
.userDetail {
  border: 15px solid #f3f3f3;
  background-color: #fff;
  box-sizing: border-box;
  // padding: 15px;
  position: relative;
  // min-height: 100%;
  .el-image {
    background-color: #f5f7fa;
    line-height: 80px;
    text-align: center;
    font-size: 20px;
  }
  .page {
    text-align: right;
  }

  .table {
    padding: 15px;
    table {
      font-size: 12px;
    }
  }
  .title {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #ccc;
    align-items: center;
    margin-bottom: 20px;
    span {
      color: #333;
    }
    i {
      color: #ccc;
    }
  }
  //   }
  // }
  .sp {
    padding: 0 20px;
    color: #1990ff;
    cursor: pointer;
  }
  .blue {
    color: #1990ff;
    cursor: pointer;
  }
  .back {
    position: absolute;
    right: 40px;
    top: 10px;
    height: 40px;
    line-height: 40px;
    color: #4276ff;
    z-index: 999;
    cursor: pointer;
  }
  .detailcontent {
    height: 100%;
    background-color: #fff;
    padding: 15px;
    .el-descriptions {
      padding-top: 20px;
      .el-descriptions__body {
        color: #333;
        border: 1px dotted #ccc;
        padding: 20px;
      }
    }
  }
  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
}
</style>
